import { defineLazyComponent } from "@/components/defineLazyComponent";

/**
 * Async-loaded wrapper around MapAreaEditor.vue, which pulls in terra-draw and
 * maplibre-gl. Always import this instead of MapAreaEditor.vue directly, so the
 * drawing libraries stay in their own chunk and aren't included in the main bundle.
 *
 * No error fallback: the component renders inside the map, where
 * `.reset-children` strips the styling off anything we put there. A failed load
 * is covered by the retries and the stale chunk reload.
 */
export const MapAreaEditorAsync = defineLazyComponent(
  () => import("./MapAreaEditor.vue"),
  { errorComponent: null },
);
